import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usd, pct } from "@/lib/format";
import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/shell/PageHeader";
import { Panel, ProvenanceTag, TableSkeleton } from "@/components/common/primitives";
import { Megaphone, Info } from "lucide-react";

export default function PPC() {
  const [d, setD] = useState(null);
  useEffect(() => { api.ppc().then((r) => setD(r.data)); }, []);
  if (!d) return <TableSkeleton rows={6} />;

  return (
    <div className="space-y-4">
      <PageHeader title="PPC Analytics" description="Read-only in Version 1. ACoS, ROAS and TACoS computed for the same period. AI explains — it cannot execute."
        meta={<><ProvenanceTag kind="fixture" /><span className="text-micro font-mono text-ink-muted">Attribution: {d.attribution_window}</span></>} />

      <Panel className="p-0 overflow-hidden" testid="ppc-campaigns">
        <div className="p-3 border-b border-edge-subtle text-compact font-medium flex items-center gap-2"><Megaphone className="h-4 w-4" />Campaigns</div>
        <table className="w-full text-compact">
          <thead><tr className="text-micro font-mono uppercase text-ink-muted text-left bg-surface-2">
            <th className="py-2 px-3">Campaign</th><th className="px-3 text-right">Spend</th><th className="px-3 text-right">Attr. sales</th>
            <th className="px-3 text-right">ACoS</th><th className="px-3 text-right">ROAS</th><th className="px-3 text-right">TACoS</th>
          </tr></thead>
          <tbody>
            {d.campaigns.map((c) => (
              <tr key={c.name} className="border-b border-edge-subtle last:border-0 hover:bg-surface-2">
                <td className="py-2 px-3 text-ink-primary">{c.name}</td><td className="px-3 text-right font-mono">{usd(c.spend)}</td>
                <td className="px-3 text-right font-mono">{usd(c.attr_sales)}</td>
                <td className={cn("px-3 text-right font-mono", c.acos > 30 ? "text-red-600" : "text-emerald-600")}>{pct(c.acos)}</td>
                <td className="px-3 text-right font-mono">{c.roas.toFixed(2)}x</td><td className="px-3 text-right font-mono">{pct(c.tacos)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>

      <Panel className="p-4" testid="ppc-recommendations">
        <div className="text-stitle text-ink-primary mb-3">Waste / opportunity queue <span className="text-micro font-mono text-ink-muted">· grounded, no Execute button in V1</span></div>
        <div className="space-y-2">
          {d.recommendations.map((r, i) => (
            <div key={i} className="rounded-ctrl border border-edge-subtle p-2.5">
              <div className="flex items-center justify-between">
                <span className="text-compact font-medium text-ink-primary flex items-center gap-2"><Info className="h-4 w-4 text-signal-violet" />{r.title}</span>
                <span className="text-micro font-mono text-ink-muted">Confidence: {r.confidence}</span>
              </div>
              <p className="text-micro text-ink-secondary mt-1 font-mono">{r.metric}</p>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
